import ApiService from '@/services/core/api.service'

const AttachmentService = {
  async retrieveCompanyLogo () {
    return ApiService.get('shared/attachments/company-logo')
  }
}

export default AttachmentService
